import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const Image = forwardRef(
  ({ alt, src, loading = 'lazy', sx, width = 100, height = 100, className, imageStyle, title }, ref) => (
    <Box
      ref={ref}
      sx={{
        width: '100%',
        height: 'auto',
        position: 'relative',
        ...sx,
      }}
      className={className}
    >
      <img
        alt={alt}
        src={src}
        title={title}
        loading={loading} // eager lazy
        width={width}
        height={height}
        style={{
          width: '100%',
          height: 'auto',
          objectFit: 'contain',
          ...imageStyle,
        }}
      />
    </Box>
  )
);

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  loading: PropTypes.any,
  className: PropTypes.string,
  title: PropTypes.string,
  sx: PropTypes.object,
  imageStyle: PropTypes.object,
};

export default Image;
